import styled from 'styled-components';

export default styled.div`
  padding: 2em;
  max-width: 1600px;
  margin: 0 auto;
  min-height: 100vh;

  .webhook-events-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2em;
    gap: 2em;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .header-content {
      display: flex;
      gap: 1em;
      align-items: flex-start;

      .header-icon {
        font-size: 2.5rem;
        color: ${({ theme }) => theme.primary};
        flex-shrink: 0;
      }

      h1 {
        font-size: 2rem;
        color: #fff;
        margin: 0 0 0.25em 0;
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        margin: 0;
      }
    }

    .btn-refresh {
      display: flex;
      align-items: center;
      gap: 0.5em;
      padding: 0.875em 1.5em;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.15);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .spinning {
        animation: spin 1s linear infinite;
      }
    }
  }

  .filters-bar {
    display: flex;
    gap: 1em;
    align-items: center;
    margin-bottom: 2em;
    padding: 1em;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;

    @media (max-width: 768px) {
      flex-wrap: wrap;
    }

    .filter-group {
      display: flex;
      align-items: center;
      gap: 0.5em;

      svg {
        color: rgba(255, 255, 255, 0.6);
      }

      select {
        padding: 0.5em 1em;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        color: #fff;
        cursor: pointer;

        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.primary};
        }

        option {
          background: #1a1d35;
          color: #fff;
        }
      }
    }

    .results-count {
      margin-left: auto;
      color: rgba(255, 255, 255, 0.6);
      font-size: 0.9rem;
    }
  }

  .webhook-events-container {
    display: grid;
    grid-template-columns: 400px 1fr;
    gap: 2em;
    min-height: 600px;

    @media (max-width: 1200px) {
      grid-template-columns: 350px 1fr;
    }

    @media (max-width: 968px) {
      grid-template-columns: 1fr;
    }
  }

  .events-sidebar {
    background: #1a1d35;
    border-radius: 12px;
    padding: 1.5em;
    max-height: calc(100vh - 300px);
    overflow-y: auto;

    .loading-state,
    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3em 1em;
      color: rgba(255, 255, 255, 0.5);

      svg {
        font-size: 3rem;
        margin-bottom: 1em;
        opacity: 0.3;
      }

      .spinning {
        animation: spin 1s linear infinite;
      }

      p {
        margin: 0;
      }
    }

    .events-list {
      display: flex;
      flex-direction: column;
      gap: 0.75em;
    }

    .event-card {
      padding: 1em;
      background: rgba(255, 255, 255, 0.03);
      border: 2px solid rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(254, 125, 17, 0.3);
      }

      &.active {
        background: rgba(254, 125, 17, 0.15);
        border-color: ${({ theme }) => theme.primary};
      }

      &.success {
        border-left: 4px solid #4CAF50;
      }

      &.failed {
        border-left: 4px solid #F44336;
      }

      .event-card-header {
        display: flex;
        align-items: center;
        gap: 0.75em;
        margin-bottom: 0.5em;

        .status-icon {
          font-size: 1.25rem;
        }

        .event-badge {
          padding: 0.25em 0.75em;
          border-radius: 12px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #fff;
        }
      }

      .event-card-body {
        margin-bottom: 0.75em;

        .event-url {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.85rem;
          font-family: 'Courier New', monospace;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.25em;
        }

        .event-status {
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.8rem;
        }
      }

      .event-card-footer {
        display: flex;
        align-items: center;
        gap: 0.5em;

        .event-time {
          display: flex;
          align-items: center;
          gap: 0.5em;
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.75rem;

          svg {
            font-size: 0.9rem;
          }
        }
      }
    }
  }

  .events-main {
    background: #1a1d35;
    border-radius: 12px;
    padding: 2em;
    min-height: 600px;

    .empty-state-main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      min-height: 400px;
      color: rgba(255, 255, 255, 0.5);

      .empty-icon {
        font-size: 4rem;
        margin-bottom: 1em;
        opacity: 0.3;
      }

      h3 {
        color: #fff;
        margin: 0 0 0.5em 0;
      }

      p {
        margin: 0;
      }
    }

    .event-details {
      .event-details-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 1.5em;
        margin-bottom: 2em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.1);

        h2 {
          color: #fff;
          margin: 0;
        }

        .status-badge {
          display: flex;
          align-items: center;
          gap: 0.5em;
          padding: 0.5em 1.25em;
          border-radius: 20px;
          font-weight: 600;

          &.success {
            background: rgba(76, 175, 80, 0.2);
            color: #81C784;
          }

          &.failed {
            background: rgba(244, 67, 54, 0.2);
            color: #E57373;
          }
        }
      }

      .detail-section {
        margin-bottom: 2em;

        h3 {
          color: #fff;
          margin: 0 0 1em 0;
          font-size: 1.25rem;
        }

        &.error-section {
          .error-message {
            padding: 1em;
            background: rgba(244, 67, 54, 0.1);
            border: 1px solid rgba(244, 67, 54, 0.3);
            border-radius: 8px;
            color: #E57373;
            font-family: 'Courier New', monospace;
          }
        }
      }

      .detail-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5em;

        @media (max-width: 768px) {
          grid-template-columns: 1fr;
        }

        .detail-item {
          label {
            display: block;
            color: rgba(255, 255, 255, 0.6);
            font-size: 0.85rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.5em;
          }

          span, code {
            color: #fff;
            font-size: 1rem;
          }

          code {
            padding: 0.5em;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            font-family: 'Courier New', monospace;
            display: inline-block;
          }

          .event-badge-large {
            padding: 0.5em 1em;
            border-radius: 16px;
            font-weight: 600;
            color: #fff;
            display: inline-block;
          }

          .url-display {
            display: flex;
            align-items: center;
            gap: 0.5em;
            padding: 0.75em;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 6px;

            code {
              flex: 1;
              padding: 0;
              background: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            a {
              color: ${({ theme }) => theme.primary};
              flex-shrink: 0;

              &:hover {
                opacity: 0.8;
              }
            }
          }

          .http-status {
            padding: 0.25em 0.75em;
            border-radius: 12px;
            font-weight: 600;
            display: inline-block;

            &.success {
              background: rgba(76, 175, 80, 0.2);
              color: #81C784;
            }

            &.failed {
              background: rgba(244, 67, 54, 0.2);
              color: #E57373;
            }
          }
        }
      }

      .json-viewer,
      .response-viewer {
        padding: 1.5em;
        background: rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #fff;
        font-family: 'Courier New', monospace;
        font-size: 0.9rem;
        overflow-x: auto;
        max-height: 400px;
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-all;
      }
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
